<template>
	<div>
		<div style="font-size: 1.2rem;font-weight: bold;" v-if="type==0">{{total}} people comment</div>
		<div style="display: flex;flex-direction: column;">
			<div style="display: flex;flex-direction: column;margin-top: 1rem;" v-for="(pitem, pindex) in data" :key="pindex">
				<div style="display: flex;align-items: center;">
					<div :style="{backgroundImage:'url('+pitem.user.avatar+')'}" class="comment-avatar"></div>
					<div style="display: flex;flex-direction: column;">
						<div class="comment-name" v-text="pitem.user.username"></div>
						<!-- <div>
							<span v-for="(tag, ctindex) in pitem.user.tags" :key="ctindex" :style="{color:colorlist[ctindex]}" class="comment-tag">#{{tag.name}}</span>
						</div> -->
						<div style="font-size: 0.5rem;color: #ccc;" v-text="format(pitem.createdAt)"></div>
					</div>
				</div>
				<div class="comment-contentbox" style="margin:1rem 0;" :style="{textIndent: pitem.isTop?'3rem':'0'}">
					<img src="../assets/imgs/comment-top.svg" style="position: absolute;width: 2.6rem;left: 2.5rem;" v-if="pitem.isTop" v-text="">
					<span v-text="pitem.content"></span>
					<span style="color: #00D8B1;font-weight: 500;" v-if="pitem.tag" v-text="'#'+pitem.tag.name"></span>
				</div>
				
				<div style="display: flex;flex-wrap: wrap;">
					<div v-for="(img, imgindex) in pitem.images" :key="imgindex" :style="{backgroundImage:'url('+img+')'}" @click="largeimg(pitem.images, imgindex)"
							style="background-position: center;background-size: cover;background-repeat: no-repeat;width: 9rem;height: 9rem;margin-right: 0.5rem;margin-bottom: 0.5rem;cursor: pointer;"></div>
				</div>
				<div style="display: flex;align-items: center;margin-top: 1rem;cursor: pointer;">
					<div @click="replyshow(pitem)" style="margin-right: 1rem;display: flex;align-items: center;">
						<img src="../assets/imgs/news/comment.svg" style="width: 1.8rem;height: 1.8rem;margin-right: 0.5rem;"><span v-text="pitem.commentCount"></span>
					</div>
					<div style="display: flex;align-items: center;">
						<img :src="pitem.liked?require('../assets/imgs/news/icon-like-light.svg'):require('../assets/imgs/news/icon-like.svg')" @click="changelike(pitem)"
									style="width: 1.5rem;height: 1.5rem;margin-right: 0.5rem;"><span v-text="pitem.likeCount"></span>
					</div>
				</div>
					<transition name="" enter-active-class="fadeInDown animated transition-02s" leave-active-class="fadeOutUp animated transition-02s">
				<div style="margin-top: 1rem;" v-if="commentreplyid == pitem.id &&commentreplyid !=''">
					<div class="chatbox">
						<textarea class="chatbox-input" cols="30" rows="10" placeholder="add reply..." v-model="commentreplycontent"
						style="height: 5rem;"></textarea>
					</div>
					<div style="display: flex;align-items: center;justify-content: flex-end;">
						<button class="btn-submit" :class="{'btn-submit-active':commentreplycontent}" @click="commentreplysubmit(pitem)">
							submit
						</button>
					</div>
				</div>
					</transition>		
				
					<div style="margin-top: 1rem;margin-left: 1rem;" v-show="pitem.commentCount" @click="showchildren(pitem)" class="loadmorereply">
						<img src="../../src/assets/imgs/arrow-down-black.png" style="width: 1rem;height: 0.5rem;margin-right: 0.5rem;" :style="{transform:pitem.isshow?'rotate(180deg)':'rotate(0deg)'}"
								class="transition-02s">
								<span v-text="pitem.commentCount"></span> replies
					</div>
					<!-- <div v-for="(childrenitem, childrenindex) in childrenlist" :key="childrenindex" v-if="childrenitem.id==pitem.id"> -->
					<div style="overflow: hidden;width: 100%;height: 100%;">
						<transition name="" enter-active-class="fadeInDown animated transition-02s" leave-active-class="fadeOutUp animated transition-02s">
							<div v-show="pitem.isshow">
								<div style="display: flex;flex-direction: column;margin-top: 1rem;margin-left: 1rem;" v-for="(citem, cindex) in pitem.children" :key="cindex">
									<div style="display: flex;align-items: center;">
										<div :style="{backgroundImage:'url('+citem.user.avatar+')'}" class="comment-avatar"></div>
										<div style="display: flex;flex-direction: column;">
											<div class="comment-name" v-text="citem.user.username"></div>
											<div>
												<span style="color: #ccc;font-size: 0.5rem;" v-text="format(citem.createdAt)"></span>
											</div>
										</div>
									</div>
									<div class="comment-contentbox" style="margin:1rem 0;background-color: #F8F8F8;border-radius: 0.5rem;padding: 1rem;" v-text="citem.content"></div>
								</div>
								<div @click="showmorechildren(pitem)" v-if="pitem.children.length != pitem.commentCount" style="margin-left: 1rem;" class="loadmorereply">show more replies</div>
							</div>
						</transition>	
					</div>	
					<!-- </div> -->
			</div>
			
			<div class="loadmorereply" style="margin-top: 1rem;" @click="loadmore" v-if="(total!=0)&&(total!=data.length)">
				click to load more comment
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				reload:true,
				page:1,
				perPage:10,
				data: Array,
				total:0,
				showchildrenid: '',
				commentdata:[],
				commentreplycontent:'',
				commentreplyid:'',
				childrendata:Array,
				childrenpage:1,
				childrenperPage:10,
				childrenlist: Array
			}
		},
		props:{
			type: '',
			id: '',
			other: '',
			tagid:'',
			keyword:'',
			commentreload: 0,
		},
		watch:{
			other(o,v){
				this.$bus.$emit('noloading', true)
				this.reload=true
				this.getdata()
			},
			tagid(o,v){
				this.$bus.$emit('noloading', true)
				this.reload=true
				this.getdata()
			},
			keyword(o,v){
				this.reload=true
				this.getdata()
			},
			commentreload(o,v){
				this.reload=true
				this.getdata()
			}
		},
		components: {
		},
		filters: {
	    },
		methods: {
			format(d){
				var date = new Date(d);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var min = date.getMinutes();
				min = min < 10 ? ('0' + min) : min;
				var s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
			},
			getdata(){
				this.$bus.$emit('noloading', true)
				let url
				if(this.type==0){
					url = '/gci/article/comment?articleId=' + this.id+'&page='+this.page+'&perPage='+this.perPage
				}
				if(this.type==1){
					
					let str = ''
					if(this.other == 1){
						str = '&isHot=1'
					}else if(this.other == 2){
						str = '&isRecommend=1'
					}
					url = '/gci/circleTopic/list?circleId='+this.id+'&tagId='+this.tagid+str+'&keyword='+this.keyword+'&page='+this.page+'&perPage='+this.perPage
					// console.info(url)
				}
				this.request({
					method: 'get',
					url: url,
				}).then(res => {
					for (let i in res.data.items) {
						res.data.items[i].isshow = false
						res.data.items[i].children = Array
						res.data.items[i].isfirst = true
					}
					if(this.reload){
						this.data = res.data.items
					}else{
						this.data = this.data.concat(res.data.items)
					}
					this.total = res.data.total
					this.reload = false
				}).catch(error => {
					console.error(error.response)
				})
			},
			largeimg(imgs, index){
				this.$bus.$emit('largeimg', {show:true, imgs:imgs, index: index})
			},
			changelike(pitem){
				let params, url
				if(this.type==0){
					params = {
						commentId: pitem.id
					}
					url = '/gci/article/comment/like'
				}
				if(this.type==1){
					params = {
						topicId: pitem.id
					}
					url = '/gci/circleTopic/like'
				}
				this.$bus.$emit('noloading', true)
				this.request({
					method: 'post',
					url: url,
					data:params
				}).then(res => {
					if(res.status==0){
						if(pitem.liked){
							pitem.likeCount--
							pitem.liked=false
						}else{
							pitem.likeCount++
							pitem.liked=true
						}
					}
					// this.getdata()
				}).catch(error => {
					console.error(error.response)
				})
			},
			commentreplysubmit(item){
				if(this.commentreplycontent==''){
					// alert('reply not empty')
					this.$bus.$emit('message',{
						type:1,
						msg:'reply not empty'
					})
				}else{
					let params, url
					if(this.type==0){
						params = {
							  articleId: this.id,
							  commentId: this.commentreplyid,
							  content: this.commentreplycontent
						}
						url = '/gci/article/comment/reply'
					}
					if(this.type==1){
						params = {
							topicId: this.commentreplyid,
							// commentId: this.commentreplyid,
							content: this.commentreplycontent
						}
						url = '/gci/circleTopic/comment'
					}
					
					this.request({
						method: 'post',
						url: url,
						data: params
					}).then(res => {
						res.data.user = JSON.parse(localStorage.getItem('user'))
						for (let i in this.data) {
							if(this.data[i].id == item.id){
								console.info(this.commentreplycontent)
								this.commentreplycontent = ''
								this.commentreplyid = ''
								this.data[i].commentCount++
								this.data[i].children.unshift(res.data)
							}
						}
						if(res.status == 0){
							// alert(res.msg)
							this.$bus.$emit('message', {
								type:2,
								msg:res.msg
							})
						}
						
					}).catch(error => {
						console.error(error.response)
					})
				}
			},
			replyshow(item){
				if(item.id == this.commentreplyid){
					this.commentreplyid = ''
				}else{
					let token = localStorage.getItem('token')
					if(token){
						this.commentreplycontent = ''
						this.commentreplyid = item.id
					}else{
						if(localStorage.getItem('isMobile')=='null'){
							this.$bus.$emit('login', true)
						}else{
							this.$router.push({name:'mlogin', query:{type:0}})
						}
					}
				}
			},
			loadmore(){
				this.page++
				this.getdata()
			},
			showmorechildren(item){
				let params, url
				if(this.type==0){
					params = {
						articleId: this.id,
						commentId: item.id,
						page: item.page?item.page+1:1,
						perPage: this.childrenperPage
					}
					url = '/gci/article/comment/reply'
				}
				if(this.type == 1){
					params = {
						topicId: item.id,
						page: item.page?item.page+1:1,
						perPage: this.childrenperPage
					}
					url = '/gci/circleTopic/comment'
				}
				this.request({
					method: 'get',
					url: url,
					params: params
				}).then(res => {
					for (let i in this.data) {
						if(this.data[i].id == item.id){
							this.data[i].children = this.data[i].children.concat(res.data.items)
							console.info(this.data[i].children)
						}
					}
				})
			},
			showchildren(item){
				// this.showchildrenid = item.id
				let isfirst = item.isfirst
				let isshow = item.isshow
				
				if(isfirst){
					let params, url
					if(this.type==0){
						params = {
							articleId: this.id,
							commentId: item.id,
							// page: this.childrenpage,
							page: item.page?pitem.page+1:1,
							perPage: this.childrenperPage
						}
						url = '/gci/article/comment/reply'
					}
					if(this.type==1){
						params = {
							topicId: item.id,
							page: item.page?item.page+1:1,
							perPage: this.childrenperPage
						}
						url = '/gci/circleTopic/comment'
					}
						this.request({
							method: 'get',
							url: url,
							params: params
						}).then(res => {
							for (let i in this.data) {
								if(this.data[i].id == item.id){
									this.data[i].page = 1
									this.data[i].children = res.data.items
									this.data[i].isfirst = false
									this.data[i].isshow = this.data[i].isshow?false:true
								}
							}
						})
				}else{
					for (let i in this.data) {
						if(this.data[i].id == item.id){
							this.data[i].isshow = !this.data[i].isshow
						}
					}	
				}
			},
		},
		mounted() {
			this.getdata()
		}
	}
	
</script>

<style scoped lang="scss">
	.comment-reply{
		font-size: 1rem;
	}
	.comment-reply:hover{
		color: #01A587;cursor: pointer;
	}
	.comment-name{
		font-size: 1rem;font-weight: bold;
	}
	.comment-tag{
		font-size: 0.5rem;margin-right: 0.5rem;
	}
	.comment-avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;
		width: 2.5rem;height: 2.5rem;border-radius: 50%;margin-right: 0.5rem;
	}
	.loadmorereply{
		color: #31ffda;cursor: pointer;
		padding: 0.4rem 0.8rem;
		background-color: #D4F9F3;
		width: max-content;
		border-radius: 1rem;
		color: #181818;
		display:flex;
		align-items:center;
		font-weight: 500;
	}
	
	.chatbox{
		border: 1px solid #DFDFDF;
		padding: 0.5rem;
		.chatbox-input{
			border: none;
			width:100%
		}
	}
	.transition-02s{
		overflow: hidden;
		animation-duration: 0.4s;
	}
</style>